import React from 'react';
import { ModalComponent, Toaster } from '@hugendubel/react-basic';
import { AppRoutes } from '../appRoutes';
import { DeliverySelectionPage } from './addresses/DeliverySelectionPage';
import { LoginMask } from './auth/LoginMask';
import { Route, Routes, useLocation } from 'react-router-dom';
import { OrderConfirmationPage } from './order/OrderConfirmationPage';
import { BonusPointHistoryPage } from './bonus/BonusPointHistoryPage';
import { Home } from './search/Home';
import { PageToTop } from './logic/PageToTop';
import { useExposeNavigate } from '../hooks/useExposeNavigate';

export const App: React.FC = () => {
    useExposeNavigate();
    const location = useLocation();

    return (
        <div className="page-container">
            <Toaster.Component />
            <LoginMask>
                <Routes>
                    <Route path={AppRoutes.DELIVERY + '/:articleId'} element={<DeliverySelectionPage />} />
                    <Route path={AppRoutes.ORDER_CONFIRMATION} element={<OrderConfirmationPage />} />
                    <Route path={AppRoutes.BONUS_POINT_HISTORY} element={<BonusPointHistoryPage />} />
                    <Route path={AppRoutes.ALL} element={<Home />} />
                </Routes>
            </LoginMask>
            <ModalComponent />
            <PageToTop location={location} />
        </div>
    );
};
